import { NextSeo } from 'next-seo';
import Breadcrumb from '@/components/breadcrumb';
import HtmlContentContainer from '@/components/html-content-container';
import LayoutBase from '@/components/layout-base';
import contentLayoutBaseData from '@/content/content-layout-base-data';
import type { CmsArticleDetail } from '@/lib/cms-article-detail';
import cmsArticleDetail from '@/lib/cms-article-detail';
import i18nMessagesLoad from '@/lib/i18n-messages-load';
import { localizationContextFromGetStaticPropsContext } from '@/lib/localization-contenxt';
import revalidateAfter from '@/lib/revalidate-after';
import type { NextGetStaticProps, NextPageWithLayout } from './_app';

type AboutUsPageProps = {
  article: CmsArticleDetail<string>;
};

const AboutUsPage: NextPageWithLayout<AboutUsPageProps> = ({ article }) => {
  const { body, metaData, teaserText, title } = article;
  const metaTagKeyWords = metaData.keyWords ? [{ content: metaData.keyWords, property: 'keywords' }] : [];
  const pageTitle = title;

  return (
    <>
      <NextSeo
        additionalMetaTags={metaTagKeyWords}
        description={metaData.description || teaserText || ''}
        title={metaData.title || title}
      />

      <main className='content-container'>
        <Breadcrumb className='py-4'>
          <Breadcrumb.Item href={`/o-nas`} isCurrenctPage={true} position={1}>
            {pageTitle}
          </Breadcrumb.Item>
        </Breadcrumb>

        <div className='mx-auto max-w-prose text-lg'>
          <h1 className='heading-page'>{pageTitle}</h1>
          <HtmlContentContainer
            applyDefaultClassName={false}
            as='section'
            className='prose prose-lg mx-auto mt-6'
            html={body}
          />
        </div>
      </main>
    </>
  );
};

AboutUsPage.displayName = 'AboutUsPage';

AboutUsPage.getLayout = (page) => {
  return <LayoutBase>{page}</LayoutBase>;
};

export default AboutUsPage;

export const getStaticProps: NextGetStaticProps<AboutUsPageProps> = async (getStaticPropsContext) => {
  const localizationContext = localizationContextFromGetStaticPropsContext(getStaticPropsContext);
  const intlMessages = await i18nMessagesLoad(localizationContext);
  const layoutData = await contentLayoutBaseData(localizationContext);
  const article = await cmsArticleDetail<string>(localizationContext, '/stranky', 'o-nas');
  if (article == null) return { notFound: true, revalidate: revalidateAfter('1m') };

  return {
    props: {
      article,
      intlMessages,
      layoutData,
    },
    revalidate: revalidateAfter('1h'),
  };
};
